import { DebugService } from './shared/services/debug.service.js';
import { SessionService } from './core/services/session/session.service.js';
import { Router } from './router.js';

class _AppService {
  constructor() {
    this.debug = new DebugService('AppService');
    this.session = SessionService.session || {};
    this._status = '';
    document.dispatchEvent(
      new CustomEvent('glia-add-custom-attributes', {
        detail: { AppId: this.session.currentApp?.appId || '' },
      }),
    );
  }

  get status() {
    this.debug.log('getting status', this._status);
    return this._status;
  }

  set status(status) {
    this._status = status;
  }

  get state() {
    return this._state;
  }

  set state(state) {
    this._state = state;
  }

  updateState({ statFlag = this.state.statFlag }) {
    this.debug.log('updateState called with', {
      statFlag,
    });
    this.state = { statFlag };
    SessionService.session = { statFlag };
  }

  updateRoute() {
    this._status = 'lender-info';
    Router.goTo(`${this._status}`);
    Router.sendStateChangedEvent(`${this._status}`);
  }
}

export const AppService = new _AppService();
